// Application types

const PUSH_NOTIFICATION = {
  LOADING: "LOADING",
  CREATING: "CREATING",
  SENDING: "SENDING",
  CREATE_PUSH_NOTIFICATION: "CREATE_PUSH_NOTIFICATION",
  SEND_PUSH_NOTIFICATION: "SEND_PUSH_NOTIFICATION",
};

export default PUSH_NOTIFICATION;
